import store from '../../store'

export default async (to, from, next) => {
  if (!store.getters['auth/isAuth']) {
    // return next({
    //   name: 'signin',
    //   query: {
    //     redirect: to.fullPath,
    //   },
    // });

    window.location.href = process.env.NODE_ENV === 'production' ? 'https://economix.ai/login' : 'https://economix.ai/login'; //'http://localhost:8082/login'
    return;

    try {
      await store.dispatch('auth/updateUserData')
    } catch (e) { }
  }

  next()
}



// WEBPACK FOOTER //
// ./src/router/middleware/onlyAuth.js